let navigate = null;

export const setGlobalNavigator = (navigateFn) => {
  navigate = navigateFn;
};

export const globalNavigate = (path, options = {}) => {
  if (navigate) {
    navigate(path, options);
  } else {
    window.location.href = path;
  }
};

const navigationRef = {
  setNavigate: (navFn) => {
    navigate = navFn;
  },
  navigate: (path, options) => {
    globalNavigate(path, options);
  }
};

export default navigationRef;

